"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var AnalyticsContext = react_1.default.createContext({
    track: function (key) {
        console.log("Analytics track event triggered: \"" + key + "\"");
        console.log("Use AnalyticsContext.Provider to implement analytics!");
    }
});
exports.default = AnalyticsContext;
